'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getProductInfo;

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get Product Info
 *
 * @param   string   productHandle - The handle of the product.
 *
 * resolve  array    The product data.
 */

function getProductInfo(productHandle) {
  return new Promise(function (resolve, reject) {
    var productUrl = '/products/' + productHandle + '.js';
    _axios2.default.get(productUrl).then(function (response) {
      resolve(response.data);
    });
  });
}